import { AdvancedMarker, Map, Pin } from '@vis.gl/react-google-maps';

import { selectPartner } from '@/context/display';
import { useAppSelector } from '@/context/storeHooks';

interface MapProps {
    mapCenter: {
        lat: number;
        lng: number;
    };
}

export function MapComponent({ mapCenter }: MapProps): JSX.Element {
    const partner = useAppSelector(selectPartner);

    return (
        <div className='w-full flex items-center justify-center'>
            <Map
                className='h-[300px] w-[300px] relative'
                defaultZoom={13}
                center={mapCenter}
                disableDefaultUI={false} // Disables all default UI controls
                mapTypeControl={false} // Disables satellite and map toggle
                streetViewControl={false} // Disables Street View control
                fullscreenControl={false} // Disables fullscreen control
                zoomControl={true} // Disables zoom buttons
                scrollwheel={false} // Disables zooming with mouse scroll
                gestureHandling='none' // Disables all map gestures
                mapId='7c34538490273e7c'
            >
                <AdvancedMarker position={mapCenter} clickable={true}>
                    <Pin
                        background={partner.primaryColor}
                        glyphColor={'#000'}
                        borderColor={'#000'}
                    />
                </AdvancedMarker>
            </Map>
        </div>
    );
}

export default MapComponent;
